import { Contract } from "appworks/utils/contracts/contract";

export function wrapContract<T>(contract: Contract<T>): Promise<T> {
    return new Promise((resolve) => {
        contract.then((value: T) => resolve(value));
    });
}